import {AdjustWeb} from "./AdjustWeb";

export class KitAdjust {

    private static readonly _adjust = new AdjustWeb();

    static Init(onChangedAction: () => void) {
        this._adjust.Init(onChangedAction);
    }

    static GetDistributor(canAccessAdjust: boolean = true): string {
        return this._adjust.GetDistributor(canAccessAdjust);
    }

    static IsReady(): boolean {
        return this._adjust.IsReady();
    }

    static GetSecondDistributor(): string {
        return this._adjust.GetSecondDistributor();
    }

    static GetAdGroup(): string {
        return this._adjust.GetAdGroup();
    }

    static GetAdjustAdid(): string {
        return this._adjust.GetAdjustAdid();
    }

    static GetCreative(): string {
        return this._adjust.GetCreative();
    }

    static IsBuyUserFlag(): boolean {
        return this._adjust.IsBuyUserFlag();
    }

    static AdjustEvent(token: string, dic: Map<string, string>) {
        this._adjust.AdjustEvent(token, dic);
    }

    static trackAdjustEvent(token: string, revenue: number) {
        this._adjust.trackAdjustEvent(token, revenue);
    }

    static AddListener(action: () => void) {
        this._adjust.AddListener(action);
    }

    static RemoveListener(action: () => void) {
        this._adjust.RemoveListener(action);
    }
}
